import { RootContext } from "components/utils/Contexts";
import FeedbucketApp from "components/utils/FeedbucketApp";
import { usePlatform } from "components/utils/PlatformContext";
import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

// Define the allowed urls to activate feedbucket
const FEEDBUCKET_PATHS = ["/home", "/editor", "/quiz"];

const RootLayout = () => {
  // States definition
  const [feedbucketUsername, setFeedbucketUsername] = useState<string | null>(null);
  const [feedbucketEmail, setFeedbucketEmail] = useState<string | null>(null);
  const [feedbucketToken, setFeedbucketToken] = useState<string | null>(null);

  // Get the platform context values
  const { feedbucketKey } = usePlatform();

  // Get the location
  const location = useLocation();

  /**
   * Funtion that returns a boolean indicating if the path
   * belongs to the allowed paths
   * @returns
   */
  const checkFeedbucketAllowedPaths = () => {
    try {
      // Process the pathname in order to get just the path
      const path = location.pathname.split("/")[1];

      // Transform into a string to be compared
      const pathStr = `/${path}`;

      // Check if the pathStr is inside the allowed feedbucket paths
      return FEEDBUCKET_PATHS.includes(pathStr);
    } catch (error) {
      console.error("Error when handling RootLayout.tsx:", error);
      return false;
    }
  };

  // Variable that controls the
  const activateFeedbucket = checkFeedbucketAllowedPaths();

  return (
    <RootContext.Provider value={{setFeedbucketUsername, setFeedbucketEmail, setFeedbucketToken}}>
      {/* Feedbucket widget */}
      <FeedbucketApp
        feedbucketKey={feedbucketKey}
        name={feedbucketUsername}
        email={feedbucketEmail}
        token={feedbucketToken}
        activate={activateFeedbucket}
      />
      {/* To show the children of this route */}
      <Outlet />
    </RootContext.Provider>
  );
};

export default RootLayout;
